import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';

export const authGuard: CanActivateFn = (route, state) => {
    const storage = inject(WebStorageService);
    const router = inject(Router);
    const user = storage.getLocalStorage('user') != null ? JSON.parse(storage.getLocalStorage('user') || 'undefined') : {};
    const regulated = JSON.parse(storage.getLocalStorage('regulated') || 'true');
    const navEntry = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming;
    const isDirectVisit = navEntry?.type === 'navigate';
    const webStorage = inject(WebStorageService)
    const isVisited = webStorage.getItem('isVisited');
    const currenytLocation = window.location.href;
    const hostName  = window.location.host;

    const baseHref = currenytLocation.split(hostName)
    if (!isVisited && isDirectVisit && baseHref[1] == '/') {
        webStorage.setItem('isVisited', true)
        router.navigate(['/dashboard'])
        return false;
    } else {
        if (regulated) {
            if (!user || !Object.keys(user).length || user.email_verified) {
                return true;
            } else {
                const currentPathName = window.location.pathname;
                console.log(":tres")
                checkEmailVerification(currenytLocation,currentPathName,(isFromEmail:boolean)=>{ 
                    if(isFromEmail){
                      return true
                    }else{
                    router.navigate(['/verify-email']);
                    return false;
                    }
                })
                
            }
        }
        webStorage.setItem('isVisited', true)
        return true;
    }
    return true;


};
/**
 * Checks email verification
 * If the user came from the email verification link allow the user to the dashboard for the verification
 * @param [windowUrl] 
 * @param [currentPathName] like we need to handle the pathname base for only the /dashboard right now the verification email contain with dashboard link alone so we need to restrict and allow to navigate.
 * @param callBack 
 * We check this condition bcz of the verification email contained /dashborad route with some queryparams so we easily find if is this verification mail or not.
 * We can check the  url if the &email is contain or not. 
 */
function checkEmailVerification (windowUrl:any='',currentPathName : string='',callBack:(result:boolean )=>any){
    let isCameFromEmail = false
if(currentPathName=='/dashboard') isCameFromEmail = windowUrl.includes('&email')
callBack(isCameFromEmail)
}



// export const rootRedirectGuard: CanActivateFn = () => {
//     const router = inject(Router);
//     const storage = inject(WebStorageService);
  
//     const userRaw = storage.getLocalStorage('user');
//     const user = userRaw ? JSON.parse(userRaw) : null;
  
//     if (user && user.email_verified) {
//       router.navigate(['/dashboard']);
//     } else if (user && !user.email_verified) {
//       router.navigate(['/verify-email']);
//     } else {
//       router.navigate(['/sign-in']);
//     }
  
//     return false; // Don't activate the root route itself
//   };
